export default "__VITE_ASSET__A_uxX17k__"